/**
 * notificationStore — OutpostForge frontend (CES standard, Zustand)
 * Application-wide notifications (apply results, API errors). The flow
 * panels currently render results inline; the CES re-skin phase adds the
 * toast UI on top of this store, and the hardening phase routes network/
 * permission errors through it.
 */

import { create } from 'zustand';

export type NotificationType = 'success' | 'error' | 'info';

export interface AppNotification {
  id: string;
  type: NotificationType;
  message: string;
  createdAt: string;
}

interface NotificationState {
  notifications: AppNotification[];
  notify: (type: NotificationType, message: string) => AppNotification;
  dismiss: (id: string) => void;
  clear: () => void;
}

let counter = 0;

export const useNotificationStore = create<NotificationState>((set) => ({
  notifications: [],

  notify: (type, message) => {
    const notification: AppNotification = {
      id: `notification-${++counter}`,
      type,
      message,
      createdAt: new Date().toISOString(),
    };
    set((state) => ({ notifications: [...state.notifications, notification] }));
    return notification;
  },

  dismiss: (id) =>
    set((state) => ({
      notifications: state.notifications.filter((n) => n.id !== id),
    })),

  clear: () => set({ notifications: [] }),
}));
